import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DataService } from '@data/data.service';
import * as dataActions from '@data/store/data.actions';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store, private dataService: DataService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((res: HttpErrorResponse) => {
        // don't catch errors to the error reporting endpoint
        if (req.url.includes('data/error-report')) {
          console.error('could not submit error report:', res);
          return throwError(() => res);
        }

        const ignoreStatus = [401, 403, 404, 405];

        if (ignoreStatus.includes(res.status)) {
          return throwError(() => res);
        }

        // stop any loading indicators
        this.dataService.showLoadingIndicator$.next(false);
        this.dataService.showSubLoadingIndicator$.next(false);
        this.dataService.showModalLoadingIndicator$.next(false);
        this.dataService.showReportParametersDialog$.next(false);

        const payload: any = {};

        payload.message = res.error?.error?.message ?? 'Unknown Exception';
        payload.type = res.error?.error?.type ?? 'server';
        payload.errorCode = res.error?.error?.errorCode ?? 'none';
        payload.statusCode = res.error?.error?.statusCode ?? res.status ?? 500;
        payload.requestId = res.error?.error?.requestId ?? res.headers.get('x-request-id') ?? 'none';

        payload.req = req;
        payload.url = req.url;
        payload.error = res;

        // handle errors returned by the reverse proxy and not the api
        if (res.status > 500) {
          payload.message = `The request could not be completed: ${res.status} ${res.statusText}`;
          payload.type = 'server';
          payload.statusCode = res.status;
          payload.errorCode = 'none';
          payload.requestId = 'none';
        }

        const title = payload.type === 'server' ? 'Server Error' : 'Error';

        // show error dialog
        this.dataService.globalModalDialogDisplay$.next(true);
        this.dataService.globalModalDialogHeader$.next(title);
        this.dataService.globalModalDialogMessage$.next(payload);

        // store error report
        this.store.dispatch(new dataActions.ApiStoreErrorReport(payload));

        return throwError(() => res);
      })
    );
  }
}
